const resource = '/v1/request-ebook';

export default $axios => ({
    create(payload) {
      return $axios.post(`${resource}`, payload);
    }
});
  